// extracted by mini-css-extract-plugin
export default {"container":"CategoryScreen_container__tJNli"};